import { getAuthToken } from '@cash-rewards/reactjs';
import axios, {
  AxiosResponse,
  CreateAxiosDefaults,
  InternalAxiosRequestConfig,
} from 'axios';

export default function createAxios<T>(config?: CreateAxiosDefaults<T>) {
  const client = axios.create(config);
  return client;
}

export const handleAxiosResponse = <T>(response: AxiosResponse<T>): T => {
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const handleAxiosResponseGracefuly = <T>(
  response: AxiosResponse<T> | null
): T | null => {
  if (response && response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    return null;
  }
};

export const authInterceptor = async (config: InternalAxiosRequestConfig) => {
  const token = await getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const silentErrorHandler = (error: any) => {
  // eslint-disable-next-line no-console
  console.error('error', error);
  return null;
};
